
// 微信sdk依赖
import * as ShareApi from "@/api/share"

// 引用全局
/* eslint-disable */
const jsApiList = [
    'checkJsApi',
    'updateTimelineShareData',
    'updateAppMessageShareData',
    'hideOptionMenu',
    'showOptionMenu',
    'shareTimeline' //不存在
];

/**
 * 全局初始化微信分享配置
 * @param {*} url 
 * @param {*} dataForWeixin 
 */
export function getJSSDK(url, dataForWeixin) {
    ShareApi.getSignature({
        url: url
    }).then((data) => {
        // console.log('process.env.NODE_ENV == %O', process.env.NODE_ENV);
        wx.config({
            // debug: true,
            debug: process.env.NODE_ENV == "development",
            // debug: process.env.NODE_ENV != "production", // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            timestamp: data.timestamp,
            appId: data.appid, // 必填，公众号的唯一标
            nonceStr: data.noncestr, // 必填，生成签名的时间戳
            signature: data.signature, // 必填，生成签名的随机串
            jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem'], // 必填，需要使用的JS接口列表
        })
        wx.error(function (res) {
            console.info(res)
        })
        this.updateShareInfo(dataForWeixin)
    }).catch((e) => {
        console.log(e.msg || e.message)
    })
}

/**
 * 更新分享内容的数据信息
 * @param {*} dataForWeixin 
 */
export function updateShareInfo(dataForWeixin) {
    wx.ready(() => {
        wx.updateTimelineShareData({
            ...dataForWeixin,
            success: function () {
                console.info('updateAppMessageShareData:ok')
            },
            cancel: function () {
                console.log('cancel');
            }
        })
        wx.updateAppMessageShareData({
            ...dataForWeixin,
            success: function () {
                console.info('updateTimelineShareData:ok')
            },
            cancel: function () {
                console.log('cancel');
            }
        })
    })
}

/**
 * 判断微信是否授权
 * @param {*} url 
 * @returns 
 */
export function weixinAuth(url) {
    console.log('weixin == ' + is_weixin())
    if (!is_weixin()) {
        return false
    }
    return true
}

/**
 * 判断使用终端是否为iOS
 * @returns Boolean
 */
export function isiOS() {
    const isIphone = navigator.userAgent.includes('iPhone')
    const isIpad = navigator.userAgent.includes('iPad')
    return isIphone || isIpad
}

/**
 * 判断是否为微信环境
 * @returns Boolean
 */
function is_weixin() {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true
    } else {
        return false
    }
}